export default __webpack_public_path__ + "static/media/settings.6f80b9fe.svg";